import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useAlert } from "react-alert";
import { baseUrl } from "../../../../services/config";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import { Table, Modal, Spinner, Alert } from "react-bootstrap";
import { Paper, Switch } from "@material-ui/core";
import { PremissionChecker } from "../../../../services/PremissionChecker";
import Select from "react-select";
function DefineSalaryExtra() {
  const alert = useAlert();
  const user = useSelector((state) => state.user.user);
  const authtoken = localStorage.getItem("userToken");
  const [loading, setloading] = useState(false);
  const [isallfields, setisallfields] = useState(false);

  const [allcampuses, setallcampuses] = useState(user.campuses || []);
  const [subAccountData, setSubAccountData] = useState([]);
  const [salaryExtraData, setSalaryExtraData] = useState([]);
  const [addSalaryLoading, setAddSalaryLoading] = useState(false);

  const [addSalaryModal, setAddSalaryModal] = useState(false);
  const [campusId, setCampusId] = useState("");
  const [subAccountId, setSubAccountId] = useState("");
  const [salaryName, setSalaryName] = useState("");
  const [isDeduction, setIsDeduction] = useState(false);

  const [editSalaryModal, setEditSalaryModal] = useState(false);
  const [editSalaryId, setEditSalaryId] = useState("");
  const [editCampusId, setEditCampusId] = useState("");
  const [editSubAccountId, setEditSubAccountId] = useState("");
  const [editSalaryName, setEditSalaryName] = useState("");
  const [editIsDeduction, setEditIsDeduction] = useState(false);

  const [deleteModal, setdeleteModal] = useState(false);
  const [deleteSalaryId, setDeleteSalaryId] = useState(0);
  const [deleteloading, setdeleteloading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);

  useEffect(() => {
    getSalaryExtra();
    subAccounts();
  }, []);

  const getSalaryExtra = async () => {
    setloading(true);
    await fetch(`${baseUrl}/salary-extras`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          if (!data.metadata.success) {
            alert.error(data.metadata.message);
            setloading(false);
            return;
          }
          setSalaryExtraData(data.payload);
          setloading(false);
        });
      })
      .catch((err) => {
        alert.error(err);
        setloading(false);
      });
  };

  const subAccounts = () => {
    fetch(`${baseUrl}/subaccount`, {
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        let arr = [];
        console.log(data);
        data.payload.forEach((element) => {
          arr.push({
            label: element.title + `(${element.acode})`,
            value: element.id,
            account_chart_id: element.account_chart_id,
          });
        });
        setSubAccountData(arr);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const addSalaryExtraHandler = async () => {
    if (salaryName == "" || campusId == "" || subAccountId == "") {
      setisallfields(true);
      return;
    }
    setisallfields(false);
    const data = {
      campus_id: campusId,
      sub_account_id: subAccountId,
      name: salaryName,
      is_deduction: isDeduction == false ? 0 : 1,
    };
    setAddSalaryLoading(true);

    await fetch(`${baseUrl}/salary-extras`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) =>
        res.json().then((data) => {
          if (data.metadata.success) {
            alert.success("Salary Extra successfully added");
            setAddSalaryModal(false);
            setAddSalaryLoading(false);
            getSalaryExtra();
            setCampusId("");
            setSubAccountId("");
            setSalaryName("");
            setIsDeduction(false);
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setAddSalaryModal(false);
            setAddSalaryLoading(false);
          } else {
            alert.show("Something Went Wrong");
            setAddSalaryModal(false);
            setAddSalaryLoading(false);
          }
        }),
      )
      .catch((err) => {
        setAddSalaryLoading(false);
        setAddSalaryModal(false);
        console.log(err);
      });
  };

  const getEditSalary = async (id) => {
    await fetch(`${baseUrl}/salary-extras/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setEditCampusId(data.payload?.campus_id);
          setEditSubAccountId(data.payload?.sub_account_id);
          setEditSalaryName(data.payload?.name);
          setEditIsDeduction(data.payload?.is_deduction);
        });
      })
      .catch((err) => {
        alert.error(err);
        setloading(false);
      });
  };

  const updateSalaryHandler = async () => {
    if (editSalaryName == "") {
      return alert.error("Name Is Required");
    }

    setSubmitLoading(true);
    const data = {
      campus_id: editCampusId,
      sub_account_id: editSubAccountId,
      name: editSalaryName,
      is_deduction: editIsDeduction == false ? 0 : 1,
    };
    setSubmitLoading(false);
    await fetch(`${baseUrl}/salary-extras/${editSalaryId}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          setSubmitLoading(false);
          if (data.metadata.success) {
            alert.success("Salary Extra Successfully Updated");
            getSalaryExtra();
            setEditSalaryModal(false);
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setEditSalaryModal(false);
          } else {
            alert.show("Something Went Wrong");
            setEditSalaryModal(false);
          }
        }
      })
      .catch((err) => {
        console.log(err);
        setSubmitLoading(false);
      });
  };

  const deleteSalaryHandle = async () => {
    setdeleteloading(true);

    await fetch(`${baseUrl}/salary-extras/${deleteSalaryId}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          if (data.metadata.success) {
            alert.success(data.payload);
            getSalaryExtra();
            setdeleteloading(false);
            setdeleteModal(false);
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setdeleteloading(false);
            setdeleteModal(false);
          } else {
            alert.show("Something Went Wrong");
            setdeleteloading(false);
            setdeleteModal(false);
          }
        }
      })
      .catch((err) => {
        console.log(err);
        console.log("err", err);
        setdeleteloading(false);
        setdeleteModal(false);
      });
  };

  return (
    <div>
      <Paper
        style={{ marginTop: "10px", marginBottom: "10px", padding: "15px" }}
      >
        <div>
          <button
            onClick={() => setAddSalaryModal(true)}
            className="btn btn-primary mr-2"
          >
            Add Salary Extra
          </button>
        </div>

        <Table className="mt-5">
          <thead>
            <tr className="text-center">
              <th>ID</th>
              <th>Name</th>
              <th>Is Deduction</th>
              {PremissionChecker(user, "campus.can_chnage_salary_extra") && (
                <th>Update</th>
              )}
              {PremissionChecker(user, "campus.can_chnage_salary_extra") && (
                <th>Delete</th>
              )}
            </tr>
          </thead>
          <tbody>
            {salaryExtraData &&
              salaryExtraData?.map((salaryExtra, index) => (
                <tr className="text-center" key={index}>
                  <td>{salaryExtra?.id}</td>
                  <td>{salaryExtra?.name}</td>
                  <td>
                    {salaryExtra?.is_deduction ? "Deduction" : "Allowance"}
                  </td>

                  {PremissionChecker(
                    user,
                    "campus.can_chnage_salary_extra",
                  ) && (
                    <td>
                      <a
                        className="btn btn-icon btn-light btn-hover-primary-custom btn-sm mx-3"
                        onClick={() => {
                          getEditSalary(salaryExtra?.id);
                          setEditSalaryId(salaryExtra?.id);
                          setEditSalaryModal(true);
                        }}
                      >
                        <span className="svg-icon svg-icon-md svg-icon-primary-custom">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Communication/Write.svg",
                            )}
                          />
                        </span>
                      </a>
                    </td>
                  )}

                  {PremissionChecker(
                    user,
                    "campus.can_chnage_salary_extra",
                  ) && (
                    <td>
                      <a
                        className="btn btn-icon btn-light btn-hover-danger btn-sm mx-3"
                        onClick={() => {
                          setDeleteSalaryId(salaryExtra?.id);
                          setdeleteModal(true);
                        }}
                      >
                        <span className="svg-icon svg-icon-md svg-icon-danger">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Communication/Delete-user.svg",
                            )}
                          />
                        </span>
                      </a>
                    </td>
                  )}
                </tr>
              ))}
          </tbody>
        </Table>
        <div className="row justify-content-center">
          {loading && <span className="spinner-border"></span>}
        </div>

        {/* Add SalaryModal */}
        <Modal show={addSalaryModal} size="lg">
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Add New Salary Extra
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="row mb-4">
              <div className="col-md-6">
                <label className="form-control-label">
                  <b>Select Campus</b>
                  <span style={{ color: "red" }}>*</span>
                </label>
                <select
                  className="form-control form-select h-40px"
                  name="campus_id"
                  value={campusId}
                  onChange={(e) => setCampusId(e.target.value)}
                  aria-label="Default select example"
                >
                  <option value="">Select Campus</option>
                  {allcampuses.map((campus, index) => (
                    <option key={index} value={campus.id}>
                      {campus.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-6">
                <label className="form-control-label">
                  <b>
                    Select Sub Account
                    <span style={{ color: "red", fontSize: 12 }}>*</span>
                  </b>
                </label>
                <Select
                  value={subAccountData.find(
                    (option) => option.value == subAccountId,
                  )}
                  onChange={(e) => setSubAccountId(e ? e.value : null)}
                  className="disselect"
                  placeholder="Select Account"
                  options={subAccountData}
                  isClearable
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <label className="form-control-label">
                  <b>
                    Enter Name <span style={{ color: "red" }}>*</span>{" "}
                  </b>
                </label>
                <input
                  className="form-control"
                  value={salaryName}
                  onChange={(e) => setSalaryName(e.target.value)}
                  placeholder="Enter Name"
                />
              </div>

              <div className="col-md-6 mt-9">
                <label className="form-control-label mr-4">
                  <b>Is Deduction</b>
                </label>
                <Switch
                  size="small"
                  onChange={(e) => {
                    setIsDeduction(e.target.checked);
                  }}
                />
              </div>
            </div>

            {isallfields ? (
              <>
                <Alert
                  variant="danger"
                  onClose={() => setisallfields(false)}
                  dismissible
                >
                  <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
                  <p>Please fill or select all fields</p>
                </Alert>
              </>
            ) : null}
          </Modal.Body>

          <Modal.Footer>
            {addSalaryLoading ? (
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            ) : (
              <button
                className="btn btn-success button_blue"
                onClick={addSalaryExtraHandler}
              >
                Add
              </button>
            )}
            <button
              className="btn btn-danger btn_width"
              onClick={() => {
                setAddSalaryModal(false);
                setisallfields(false);
                setCampusId("");
                setSubAccountId("");
                setSalaryName("");
                setIsDeduction(false);
              }}
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>

        {/* Update SalaryModal */}
        <Modal show={editSalaryModal} size="lg">
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Update Salary Extra
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row mb-4">
              <div className="col-md-6">
                <label className="form-control-label">
                  <b>Select Campus</b>
                  <span style={{ color: "red" }}>*</span>
                </label>
                <select
                  className="form-control form-select h-40px"
                  name="campus_id"
                  value={editCampusId}
                  onChange={(e) => setEditCampusId(e.target.value)}
                  aria-label="Default select example"
                >
                  <option value="">Select Campus</option>
                  {allcampuses.map((campus, index) => (
                    <option key={index} value={campus.id}>
                      {campus.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-6">
                <label className="form-control-label">
                  <b>
                    Select Sub Account
                    <span style={{ color: "red", fontSize: 12 }}>*</span>
                  </b>
                </label>
                <Select
                  value={subAccountData.find(
                    (option) => option.value == editSubAccountId,
                  )}
                  onChange={(e) => setEditSubAccountId(e ? e.value : null)}
                  className="disselect"
                  placeholder="Select Account"
                  options={subAccountData}
                  isClearable
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <label className="form-control-label">
                  <b>
                    Enter Name <span style={{ color: "red" }}>*</span>{" "}
                  </b>
                </label>
                <input
                  className="form-control"
                  value={editSalaryName}
                  onChange={(e) => setEditSalaryName(e.target.value)}
                  placeholder="Enter Name"
                />
              </div>

              <div className="col-md-6 mt-9">
                <label className="form-control-label mr-4">
                  <b>Is Deduction</b>
                </label>
                <Switch
                  size="small"
                  onChange={(e) => {
                    setEditIsDeduction(e.target.checked);
                  }}
                  checked={editIsDeduction == 1 ? true : false}
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            {submitLoading ? (
              <div
                style={{
                  width: "80px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Spinner
                  className="text-center"
                  variant="info"
                  animation="border"
                />
              </div>
            ) : (
              <button onClick={updateSalaryHandler} className="btn btn-primary">
                Update
              </button>
            )}

            <button
              onClick={() => setEditSalaryModal(false)}
              className="btn btn-danger"
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>

        {/* Delete  Salary Modal */}
        <Modal show={deleteModal}>
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Are you sure want to delete this salary extra?
            </Modal.Title>
          </Modal.Header>
          {deleteloading ? (
            <div style={{ padding: "20px" }}>
              {" "}
              <b style={{ color: "green" }}>
                {" "}
                Salary Extra Deleting Please Wait{" "}
                <span className="spinner-borderd"></span>
              </b>
            </div>
          ) : (
            <Modal.Footer>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <button
                  onClick={deleteSalaryHandle}
                  className="btn button_blue"
                >
                  Delete
                </button>
                <button
                  style={{ marginLeft: "10px" }}
                  onClick={() => setdeleteModal(false)}
                  className="btn btn-danger btn_width"
                >
                  Cancel
                </button>
              </div>
            </Modal.Footer>
          )}
        </Modal>
      </Paper>
    </div>
  );
}

export default DefineSalaryExtra;
